(function (app, ng) {

    app.controller("editCustomFieldController", editCustomFieldController);

    function editCustomFieldController(customFieldApi, _formPattern, $mdDialog, modalService, $scope, $state) {
        const $ctrl = this;
        ng.extend($ctrl, {
            datePicker: {
                days: [],
                months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
                years: []
            },
            domainTypes: [
                { Id: '1', Name: 'Contact (Personal)', Value: 'Client' },
                { Id: '2', Name: 'Insurance Account', Value: 'InsuranceAccount' },
                { Id: '3', Name: 'Investment Account', Value: 'InvestmentAccount' },
                { Id: '4', Name: 'All Accounts', Value: 'AllAccounts' }
            ],
            customFieldTypes: [
                { Id: 1, Name: 'Text', Value: 'Text' },
                { Id: 2, Name: 'Text Area', Value: 'TextArea' },
                { Id: 3, Name: 'Drop-down List', Value: 'DropDownList ' },
                { Id: 4, Name: 'Radio List', Value: 'RadioList' }
                //{ Id: 5, Name: 'Checkbox List', Value: 'CheckboxList' }
                //{ Id: 4, Name: 'Radio', Value: 'Radio' },
                //{ Id: 6, Name: 'Checkbox', Value: 'Checkbox' },
            ],
            formPattern: _formPattern
        });

        $ctrl.close = () => {
            $mdDialog.hide();
        }; 

        $ctrl.addOptions = (option) => {
            //check that added string doens't already exist in array
            var searchTerm = option.toLowerCase();
            if (!!option && $ctrl.customField.TextOptionsList.length < 1 ) {
                $ctrl.customField.TextOptionsList.push(option);
                $ctrl.newOption = null;
            } else if (!!option && !!$ctrl.customField.TextOptionsList && !_.find($ctrl.customField.TextOptionsList, function (row) { return row.toLowerCase() === searchTerm; })) { $ctrl.customField.TextOptionsList.push(option); }
            $ctrl.newOption = null;
        };

        $ctrl.removeOption = (option) => {
            $ctrl.customField.TextOptionsList = _.remove($ctrl.customField.TextOptionsList, (activeOption) => {
                return activeOption !== option;
            });
        };

        $ctrl.remove = (customField, $event) => {
            modalService.confirmCustomFieldDeletion(customField.FieldName, $event)
                .then(() => {
                    $ctrl.loading = true;

                    customFieldApi.remove(customField)
                        .then(() => {
                            $ctrl.close($event);
                            return $state.go("Home.Settings.CRMSetup.CustomFields", {}, { reload: true });
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            $ctrl.loading = false;
                        });
                });
        };
        $ctrl.updateCustomField = (customField, $event) => {
            $ctrl.loading = true;
            customFieldApi.update(customField)
                .then(() => {
                    $ctrl.close($event);
                    return $state.go("Home.Settings.CRMSetup.CustomFields", {}, { reload: true });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    $ctrl.loading = false;
                });
        };

        $scope.enterCheck = (e) => {
            if (e.which === 13 || e.keyCode === 13) {
                return $ctrl.addOptions($ctrl.newOption);
            } else { return false; }
        };

        $ctrl.onInit = () => {
        };
    }

})(window.app, window.angular);